import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchemaIcon from '@mui/icons-material/Schema';
import SettingsIcon from '@mui/icons-material/Settings';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CONFIGS_PATH, DEPLOYMENTS_PATH, SCHEMAS_PATH, SERVERS_PATH } from '../routes';
import { Stack, Typography } from '@mui/material';

interface MainNavTab {
  readonly name: string;
  readonly path: string;
  readonly icon: React.ReactElement;
}

const UNSELECTED_TAB_VALUE = null;

const MAIN_NAV_TABS: MainNavTab[] = [
  { name: 'Servers', path: SERVERS_PATH, icon: <DashboardIcon /> },
  { name: 'Configurations', path: CONFIGS_PATH, icon: <SettingsIcon /> },
  { name: 'Schemas', path: SCHEMAS_PATH, icon: <SchemaIcon /> },
  { name: 'Deployments', path: DEPLOYMENTS_PATH, icon: <RocketLaunchIcon /> },
];

const findTabIndexByPath = (pathname: string): number | null => {
  const tabIndex = MAIN_NAV_TABS.findIndex(tab => tab.path === pathname);

  return tabIndex !== -1 ? tabIndex : UNSELECTED_TAB_VALUE;
};

const MainNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTabIndex, setActiveTabIndex] = useState<number | null>(UNSELECTED_TAB_VALUE);

  useEffect(() => {
    const foundTabIndex = findTabIndexByPath(location.pathname);
    if (foundTabIndex !== UNSELECTED_TAB_VALUE) {
      setActiveTabIndex(foundTabIndex);
    }
  }, [location]);

  const handleChange = (event: React.SyntheticEvent, index: number) => {
    setActiveTabIndex(index);
    navigate(MAIN_NAV_TABS[index].path);
  };

  return (
    <AppBar position="fixed">
      <Toolbar variant="dense">
        <Stack direction='row' alignItems='center' sx={{ mr: 5 }}>
          <img src="/logo50.png" alt="logo" />
          <Stack direction='column' sx={{ ml: 1 }}>
            <Typography sx={{ fontWeight: 600, letterSpacing: '.1rem' }}>Kannel</Typography>
            <Typography sx={{ fontWeight: 600, letterSpacing: '.1rem' }}>Monitoring</Typography>
          </Stack>
        </Stack>

        <Tabs
          textColor="inherit"
          indicatorColor="secondary"
          value={activeTabIndex !== UNSELECTED_TAB_VALUE ? activeTabIndex : false}
          onChange={handleChange}
        >
          { MAIN_NAV_TABS.map((menuTab, index) => (
            <Tab key={index} value={index} label={menuTab.name} icon={menuTab.icon} />
          ))}
        </Tabs>
      </Toolbar>
    </AppBar>

  );
};

export default MainNavBar;
